import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { TermsPage } from './pages/Terms';
import { AboutPage } from './pages/About';
import { PortfolioPage } from './pages/Portfolio';
import { ContactPage } from './pages/Contact';
import { ServicesPage } from './pages/Services';
import { PrivacyPolicyPage } from './pages/PrivacyPolicy';
import { Navbar, Footer, AppointmentModal } from './components/sections';
import { ChatBox, ScrollToTopButton } from './components/ui'

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isAppointmentOpen, setIsAppointmentOpen] = useState(false);

  const handleOpenConsultation = () => {
    setIsAppointmentOpen(true);
  };

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <div className="min-h-screen bg-[#f5f9fc] dark:bg-[#080e1a] text-slate-900 dark:text-slate-100 font-sans selection:bg-[#4a82c2] selection:text-white antialiased transition-colors">
        <Navbar onOpenConsultation={handleOpenConsultation} />

        <Routes>
          <Route path="/" element={<Home onOpenConsultation={handleOpenConsultation} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage onOpenConsultation={handleOpenConsultation} />} />
          <Route path="/portfolio" element={<PortfolioPage onOpenConsultation={handleOpenConsultation} />} />
          <Route path="/contact" element={<ContactPage onOpenConsultation={handleOpenConsultation} />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>

        <Footer />
        <ChatBox onOpenConsultation={handleOpenConsultation} />
        <ScrollToTopButton />
        <AppointmentModal isOpen={isAppointmentOpen} onClose={() => setIsAppointmentOpen(false)} />
      </div>
    </Router>
  );
}

export default App;
